var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationLayout',{attrs:{"back":true,"menu":true}},[_c('AccountHeader',{attrs:{"user":_vm.user}}),_vm._v(" "),_vm._l((_vm.getI18n),function(menu,index){return _c('MenuList',{key:index,attrs:{"name":menu.name,"items":menu.items}})}),_vm._v(" "),_c('ButtonLanguage')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185db104","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account.vue
// module id = OZtA
// module chunks = 0